import { render, staticRenderFns } from "./TOTMaterials.vue?vue&type=template&id=1cd88cb4"
import script from "./TOTMaterials.vue?vue&type=script&lang=js"
export * from "./TOTMaterials.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports